import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";
import { CacheInvalidator } from "@/utils/cache/cache-invalidator";

export class ActivatePatientUsecase {
  //MARK:- Constructor
  constructor(
    private readonly patientRepo: PatientRepository,
    private readonly patientListCache?: CacheInvalidator
  ) {}

  //MARK:- execute
  async execute(patientUuid: string): Promise<SATResult<void, SATError>> {
    const result = await this.patientRepo.activatePatient(patientUuid);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    // 환자 목록 캐시가 변경 전 데이터를 보여주지 않도록 비움
    this.patientListCache?.invalidate();
    return SATResult.success(void 0);
  }
}
